import { Box, Button, Divider, Flex, Text } from '@mantine/core';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { TransactionFormData } from '../../../shared/types';
import classes from './TransactionForm.module.css';
import { BetaIcon } from '../../../../lib/components';
import ImportedReferencesModal from './ImportedReferencesModal';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';

export const importedDdsSchema = yup.array().of(
  yup.object().shape({
    reference: yup.string(),
    verification: yup.string(),
  })
);

const ImportedReferences = () => {
  const {
    control,
    formState: { disabled },
  } = useFormContext<TransactionFormData>();
  const { fields, remove, append } = useFieldArray({
    control,
    name: 'importedDds',
  });
  const { t } = useTranslation();

  const handleRemoveReference = (index: number) => {
    remove(index);
  };

  return (
    <Flex direction="column" gap="md" mt="md">
      <Text size="sm">
        {t('transactions.form.importedReferences')}
        <Text size="sm" fs="italic" component="div">
          {t('common.optional')}
        </Text>
      </Text>

      {fields
        .filter((field) => field.reference && field.verification)
        .map((field, index) => {
          const importedDds = field as unknown as {
            reference: string;
            verification: string;
          };
          return (
            <Flex key={field.id} className={classes.importedReferencesCard}>
              <Box>
                <Text c="dark.6">{t('transactions.form.referenceNo')}</Text>
                <Text>{importedDds.reference ?? ''}</Text>
              </Box>

              <Box>
                <Text c="dark.6">{t('transactions.form.verificationNo')}</Text>
                <Text>{importedDds.verification ?? ''}</Text>
              </Box>
              {
                <Button
                  variant="transparent"
                  onClick={() => handleRemoveReference(index)}
                  p={4}
                  data-testid="delete-reference-button"
                  style={{ visibility: disabled ? 'hidden' : 'visible' }}
                >
                  <BetaIcon icon="trash" size="lg" />
                </Button>
              }
            </Flex>
          );
        })}

      <ImportedReferencesModal appendDds={append} />

      <Divider color="dark.6" variant="dashed" mb={4} />
    </Flex>
  );
};

export default ImportedReferences;
